<template>
    <div class="parent-loader-container">
        <div class="preloader">
            <div class="loader"></div>
        </div>
    </div>
</template>